// JsFromRoutes CacheKey 317b8b0d63bde3908ebac99a6f2c1087
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/sponsorship/areas"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/sponsorship/areas"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/sponsorship/areas/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/sponsorship/areas/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/sponsorship/areas/:id"),
}
